import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { KnotIcon } from './Icons';
export const PainSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section className="py-12 md:py-24 px-4 md:px-6 bg-[#f4ece3] relative" ref={ref} data-id="element-117">
      <div className="max-w-3xl mx-auto" data-id="element-118">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.8
      }} className="bg-white p-6 md:p-16 rounded-sm shadow-luxury relative" data-id="element-119">
          <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 bg-[#f4ece3] p-2 rounded-full" data-id="element-120">
            <KnotIcon className="w-8 h-8 text-brown" data-id="element-121" />
          </div>

          <h3 className="text-2xl md:text-3xl font-serif text-brown mb-8 text-center" data-id="element-122">
            Es frustrante.
          </h3>

          <div className="space-y-6 text-lg text-charcoal/80 font-light leading-relaxed" data-id="element-123">
            <p data-id="element-124">
              Intentas meditar y tu mente vuela a las facturas o al último
              diagnóstico médico. Intentas descansar y la culpa por no ser
              "productiva" te consume.
            </p>
            <p data-id="element-125">
              Ves pasar los días sintiéndote una espectadora en tu propia casa,
              con una creatividad que grita por salir pero no sabe por dónde
              empezar.
            </p>
            <p className="pt-4 border-t border-beige" data-id="element-126">
              Peor aún, sientes la presión financiera del hogar, pero la idea de
              un trabajo estresante frente a una pantalla te agota de solo
              pensarlo.
            </p>
            <p className="font-medium text-brown text-xl text-center pt-4" data-id="element-127">
              Te falta un puente. Un puente que una tu necesidad de calma con tu
              deseo de independencia.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
};